<template>
  <modal back="product" :title="$t('customization.changeProduct')">
    <menu-item
      to="product-filter"
      @click.native="
        trackPath({
          virtPath: 'product',
          contentGroup2: 'Creator_Product',
          contentGroup3: 'Creator_Filter'
        })
      "
    >
      {{ $t('customization.filterProductLabel') }}
      <span v-if="$store.getters.filterCountTotal > 0"
        >({{ $store.getters.filterCountTotal }})</span
      >
    </menu-item>
    <search
      v-model.trim="filterTerm"
      :placeholder="$t('customization.filterProductName')"
      class="search"
    ></search>
    <collection-grid :designs="gridItems" @item-clicked="selectProduct" />
  </modal>
</template>
<script>
import CollectionGrid from '../../components/CollectionGrid.vue';
import Modal from '../../components/Modal.vue';
import MenuItem from '../../components/MenuItem.vue';
import { ACTION_LIST_PRODUCTS } from '../../store/action-types';
import { ACTION_AWAIT_REQUEST } from '../../store/action-types';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import Redirect from '@/mixins/redirect';
import Search from '../../components/input/Search.vue';

export default {
  name: 'ProductChange',
  components: {
    Search,
    CollectionGrid,
    Modal,
    MenuItem
  },
  mixins: [TrackingMixin, Redirect],
  data: () => ({
    filterTerm: ''
  }),
  computed: {
    gridItems() {
      return this.$store.state.products
        .map(item => ({
          ...item,
          thumbnail: item.mainImage.replace(/^https?:/, ''),
          label: item.name,
          selected: item.number === this.$store.state.product.info.articleNumber
        }))
        .filter(item =>
          item.label.toLowerCase().includes(this.filterTerm.toLowerCase())
        );
    }
  },
  async mounted() {
    this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
      await this.$store.dispatch(ACTION_LIST_PRODUCTS);
    });
  },
  methods: {
    selectProduct(product) {
      this.trackEvent({
        action: 'Product_Change',
        label:
          this.$store.state.product.info.articleNumber.replace(/-.*/, '') +
          'T' +
          product.number.replace(/-.*/, '')
      });
      this.$root.$emit('reset-navigation');
      this.redirect('product', 'instant');
      this.$router.push({
        name: 'root',
        params: { articleNumber: product.number }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.search {
  @apply w-full my-3;
}
</style>
